<template>
  <div
    class="ag-event-count-list p-4"
    v-if="ancestorList && ancestorList !== 'null'"
  >
    <div id="ag-table" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="table-responsive">
        <table class="table table-hover" v-if="ancestorList">
            <thead>
                <tr>
                    <th>{{$t("commandLine")}}</th>
                    <th>{{$t("creatorPID")}}</th>
                    <th>{{$t("pid")}}</th>
                    <th>{{$t("creatorPID")}}</th>
                    <th>{{$t("path")}}</th>
                    <th>{{$("surrogatePID")}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, key) in ancestorList" :key="key">
                    <td>{{item.CommandLine}}</td>
                    <td>{{item.CreatorPID}}</td>
                    <td>{{item.PID}}</td>
                    <td>{{item.ParentPID}}</td>
                    <td>{{item.Path}}</td>
                    <td>{{item.SurrogatePID}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";
const store = useStore();
export default {
  name: "ag-event-count-list",
  data: () => ({
    ancestorList: false,
  }),
  mounted() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
  },
  components: {},
  methods: {
    getList() {
      if (store.state.general.selectedExpandedRow.ancestorList) {
        this.ancestorList =
          store.state.general.selectedExpandedRow.ancestorList;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
}

.ag-event-count-list {
  font-size: 14px;
}
</style>
